import AddTeamModal from './AddTeamModal';

export default AddTeamModal;
